import { IMenuItem } from "./IMenuItem";

export function addMyAccountDropDownMenu(
  menu: IMenuItem[],
  content: { links: IMenuItem[] }
): IMenuItem[] {
  const myAccountChildLinks = content.links;
  return menu.map(
    menuItem =>
      menuItem.title === "For Home"
        ? {
            ...menuItem,
            children: menuItem.children.map(
              childMenuItem =>
                childMenuItem.title === "My Account"
                  ? {
                      ...childMenuItem,
                      children: myAccountChildLinks
                    }
                  : childMenuItem
            )
          }
        : menuItem
  );
}
